import React from 'react';
import OrderFileList from '../components/OrderFiles/OrderFileList';

const OrderFilesPage: React.FC = () => {
    return (
        <div className="order-files-page">
            <OrderFileList />
        </div>
    );
};

export default OrderFilesPage; 